import { supportsPushState, isInApp } from './index';
import { getCookie } from './cookie';
import ssrGlobal from '@/util/ssr-global';

let uaInfo: {
    os: {
        name?: string;
        version?: string;
    },
    model?: string;
};

let lastUA = ssrGlobal?.navigator?.userAgent || ''

export const getUAInfo = (ua = ssrGlobal?.navigator?.userAgent) => {
    if (uaInfo && ua === lastUA) {
        return uaInfo;
    }
    const UNKNOWN = 'unknow';
    const androidReg = /android/i;
    const MacOS = 'Mac OS';
    const Windows = 'Windows';
    const Android = 'Android';
    const iPhone = 'iPhone';
    const iPad = 'iPad';
    const WinPhone = 'Windows Phone';
    const Linux = 'Linux';
    uaInfo = {
        os: {
            name: UNKNOWN,
            version: UNKNOWN
        },
        model: UNKNOWN
    };
    try {
        const uaMatches = ua.match(/\((.*?)\)/);
        if (!uaMatches) {
            const isAndroid = androidReg.test(ua);
            if (isAndroid) {
                uaInfo.os.name = Android;
            }
            return uaInfo;
        }
        const uaMain = uaMatches[1] + ')';
        const uaArr = uaMain.split(';').map(str => str.trim());
        let osName, osVersion, model;
        if (ua.indexOf(WinPhone) > -1) {
            model = osName = WinPhone;
            const matches = uaMain.match(/Windows\sPhone\s(.*?)[;\)\s]/);
            if (matches) {
                osVersion = matches[1];
            }
            model = uaArr[uaArr.length - 1]?.replace(')', '');
        } else if (androidReg.test(ua)) {
            // 安卓 ua 信息解析
            osName = Android;
            const modelMatches = uaMain.match(/android.*?;(.*?)build\//i);
            if (modelMatches) {
                model = modelMatches[1]?.split(';').pop();
                model = model && model.trim();
            }
            for (let i = 0; i < uaArr.length; i++) {
                if (androidReg.test(uaArr[i]!)) {
                    osVersion = uaArr[i]?.replace(androidReg, '');
                    if (!model) {
                        model = uaArr[i + 1];
                    }
                    break;
                }
            }
        } else if (ua.indexOf(iPhone) > -1 || ua.indexOf(iPad) > -1) {
            // iOS 系统信息解析
            model = ua.indexOf(iPhone) > -1 ? iPhone : iPad;
            osName = 'iOS';
            const matches = uaMain.match(/OS\s(.*?)\slike/);
            if (matches) {
                osVersion = matches[1];
            }
        } else if (ua.indexOf(MacOS) > -1) {
            // Mac OS 系统信息解析
            model = osName = MacOS;
            const matches = uaMain.match(/OS\sX\s(.*?)[;\)\s]/);
            if (matches) {
                osVersion = matches[1];
            }
        } else if (ua.indexOf(Windows) > -1) {
            model = osName = Windows;
            const matches = uaMain.match(/Windows\s(.*?)[;\)]/);
            if (matches) {
                osVersion = matches[1];
            }
        } else if (ua.indexOf('Nokia') > -1) {
            osName = 'Symbian';
            const vMatches = ua.match(/Symbian.*?\/(.*?);/);
            if (vMatches) {
                osVersion = vMatches[1];
            }
            const mMatches = ua.match(/Nokia(.*?)\//);
            if (mMatches) {
                model = mMatches[1];
            }
        } else if (uaMain.indexOf(Linux) > -1) {
            osName = model = Linux;
        }
        uaInfo = {
            os: {
                name: osName || UNKNOWN,
                version: osVersion && osVersion.replace(/_/g, '.').trim() || UNKNOWN
            },
            model: model || UNKNOWN
        };
    } catch (err) {
        console.error('[109]', 'UA 信息解析错误', (err as Error).message);
    }
    return uaInfo;
};


/**
 * http://git.corp.kuaishou.com/ks-frontend/modules/web-util/blob/master/src/device.js
 */
const kpnFromUA = () => {
    if (typeof window === 'undefined') return '';
    let ua = window.navigator.userAgent;
    // 注意顺序很重要
    let rules = [
        [/ Kwai\//, 'KUAISHOU'],
        [/ ksthanos\//, 'THANOS'],
        [/ ksNebula\//i, 'NEBULA'],

        // iOS 审核移除敏感信息
        // [/ wxwork\//, 'workWechat'],
        // [/ MicroMessenger\//, 'wechat'],
        // [/ QQ\//, 'qq'],
        // [/__weibo__([^_]+)/, 'weibo'],
        // [/ livemate\//, 'livemate'],
        // [/ baiduboxapp\//, 'baidu'],

        // [/ MQQBrowser\//, 'qqBrowser'],
        // [/\(MSIE ([^;]+);/, 'ie'],
    ];

    for (let i = 0; i < rules.length; i++) {
        let tmp = rules[i]!;
        let rule = tmp[0];
        let name = tmp[1];
        let rRes = (rule as RegExp).exec(ua);
        if (rRes) {
            return name;
        }
    }
    return '';
};

/**
 * 获取默认的 KPN,TODO: 副作用函数
 */
let defaultKpn: string;
export function getDefaultKpn() {
    if (defaultKpn === undefined) {
        defaultKpn = isInApp() && getCookie('kpn') || kpnFromUA() || '';
    }
    return defaultKpn;
}

/**
 * 判断是否是 kds 环境
 */
export const isKDSNative = (() => {
    let res: boolean | undefined;
    return () => {
        if (typeof res !== undefined) return res;
        const platform = ssrGlobal?.navigator?.platform?.toLowerCase();
        res = !!(platform && ['ios', 'android'].indexOf(platform) !== -1);
        return res;
    }
})();

export default {
    supportsPushState,
    getUAInfo,
    getDefaultKpn
};
